var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6471 7.17647H1M18.6471 7.17647C18.6471 3.76397 21.411 1 24.8235 1C28.236 1 31 3.76397 31 7.17647C31 10.589 28.236 13.3529 24.8235 13.3529C21.411 13.3529 18.6471 10.589 18.6471 7.17647ZM31 24.8235H16.8824M16.8824 24.8235C16.8824 28.236 14.1184 31 10.7059 31C7.29338 31 4.52941 28.236 4.52941 24.8235M16.8824 24.8235C16.8824 21.411 14.1184 18.6471 10.7059 18.6471C7.29338 18.6471 4.52941 21.411 4.52941 24.8235M4.52941 24.8235H1",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.54c20e7ce3a511438c5f06459b07c8c4.svg";
export { ForwardRef as ReactComponent };